import { apiUrls, connectionTypes } from 'consts'
import { useEffect } from 'react'
import loadRecord from '../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    if (props.id !== undefined) {
      loadRecord(apiUrls.connections, props.id).then((data) => {
        const type = connectionTypes.find(t => t.id === data.type)
        props.reset({
          ...data,
          type: type
        })
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
        props.setDataLoaded(true)
        props.setShowOverlay(false)
        props.reset({
          type: connectionTypes[0]
        })
    }
  }, [props.currentCustomer])
}

export default useInit
